import tactrlLogo from '@/assets/images/MainLogo.svg'
import React from 'react'
import { usePushHistory } from '@/utils/hooks'
import styled from 'styled-components'
import { useCompany } from '@/utils/hooks'
import { CompanyLogo } from './CompanyLogo/'

interface LogoWrapperProps {
  $companyLogo: boolean
}

const Wrapper = styled.div<LogoWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: ${props => (props.$companyLogo ? 'center' : 'flex-start')};

  width: 100%;
  height: calc(${props => props.theme.layout.headerHeight} - 1.6em);
  margin-bottom: 1.4rem;

  padding: 0.5em 0.5em 0 0.5em;

  span {
    margin-left: 0.8em;
    font-size: 1.4em;
    font-weight: 700;
    color: ${props => props.theme.colors.primary};
  }
`

const TitleImage = styled.img`
  height: 34px;
`

export const SidebarTop: React.FC = () => {
  const pushHistory = usePushHistory()
  const company = useCompany()
  const renderCompanyLogo = !!company.logo && company.useCompanyLogo

  return (
    <Wrapper $companyLogo={renderCompanyLogo}>
      {renderCompanyLogo ? (
        <CompanyLogo logo={company.logo!} />
      ) : (
        <a
          href="/"
          onClick={evt => {
            evt.preventDefault()
            pushHistory('/', evt)
          }}
        >
          <TitleImage src={tactrlLogo} />
        </a>
      )}
    </Wrapper>
  )
}
